import React from "react";

import {
  Badge,
  Flex,
  FlexItem,
  Tooltip
} from "@patternfly/react-core";

const QualificationBadge = ({ qualification }) => (
  <>
    <Tooltip
      content={
        <div>{qualification.qualification_name}</div>
      }
    >
      <Badge isRead>
        {qualification.qualification_symbol}
      </Badge>
    </Tooltip>{" "}

    <Tooltip
      content={
        <div>
          Ilość arkuszy dla {qualification.qualification_symbol}
        </div>
      }
    >
      <Badge
        style={{
          backgroundColor: "#009596",
          color: "white"
        }}
      >
        {qualification.number_of_sheets}
      </Badge>
    </Tooltip>{" "}
  </>
);

const QualificationBadges = ({
  activeQualifications,
  inactiveQualifications
}) => {
  const qualifications = [
    ...activeQualifications,
    ...inactiveQualifications
  ];

  return (
    <Flex
      flexWrap={{ default: "wrap" }}
      gap={{ default: "gapSm" }}
    >
      {qualifications.map((qualification) => (
        <FlexItem key={qualification.qualification_symbol}>
          <QualificationBadge
            qualification={qualification}
          />
        </FlexItem>
      ))}
    </Flex>
  );
};

export default QualificationBadges;